import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import ProjectLoader from './ProjectLoader/ProjectLoader';

export default function Routes() {
  return (
    <DocumentTitle title="Project">
      <Route path="/project/:opportunityId" component={ProjectLoader} />
    </DocumentTitle>
  );
}
